(function () {
  var AVAILABILITY_PARAM = "filter.v.availability";
  var IN_STOCK_VALUE = "1";

  /**
   * Size + Availability together restrict to variants in stock for the selected size.
   * When sizes are selected, force In stock. When sizes are cleared, drop availability.
   */
  function syncAvailabilityForSize(params, hasSizeSelection) {
    params.delete(AVAILABILITY_PARAM);
    if (hasSizeSelection) {
      params.append(AVAILABILITY_PARAM, IN_STOCK_VALUE);
    }
    return params;
  }

  window.CalypsaShopBySize = {
    syncAvailabilityForSize: syncAvailabilityForSize,
    AVAILABILITY_PARAM: AVAILABILITY_PARAM,
    IN_STOCK_VALUE: IN_STOCK_VALUE,
  };
})();

class ShopBySize extends HTMLElement {
  connectedCallback() {
    this.paramName = this.dataset.paramName;
    this.addEventListener("change", this.onChange);
  }

  disconnectedCallback() {
    this.removeEventListener("change", this.onChange);
  }

  getFiltersForm = () => {
    const forms = [...document.querySelectorAll("collection-filters-form")];
    if (!forms.length) return null;

    const visible = forms.find((form) => {
      const style = window.getComputedStyle(form);
      return style.display !== "none" && style.visibility !== "hidden";
    });

    return visible || forms[0];
  };

  getSelectedSizeValues = () => {
    return [...this.querySelectorAll('input[type="checkbox"][name="shop-by-size"]:checked')].map(
      (checkbox) => checkbox.value
    );
  };

  onChange = (event) => {
    const input = event.target;
    if (!input.matches('input[type="checkbox"][name="shop-by-size"]')) return;

    const filtersForm = this.getFiltersForm();
    if (!filtersForm?.renderPage) return;

    const paramName = input.dataset.paramName || this.paramName;
    if (!paramName) return;

    const params = new URLSearchParams(window.location.search);
    params.delete(paramName);

    const selected = this.getSelectedSizeValues();
    selected.forEach((value) => {
      params.append(paramName, value);
    });

    window.CalypsaShopBySize.syncAvailabilityForSize(params, selected.length > 0);
    params.delete("page");

    filtersForm.renderPage(params.toString());
  };
}

customElements.define("shop-by-size", ShopBySize);
